import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

import routerUsers from "@/router/users";
import routerMaterials from "@/router/materials";
import routerRegions from "@/router/regions";
import routerStores from "@/router/stores";
import routerBanners from "@/router/banners";
import routerApproval from "@/router/approval";
import routerAudit from "@/router/audit";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * disabled: true                 if set true, item will disabled link in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    activeMenuParent: true     if set true, the parent item will highlight
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        // redirect: "/entry/list",
        component: () => import("@/views/Dashboard.vue"),
        meta: { title: "Главная", icon: "dashboard" },
      },
    ],
  },
  // {
  //   path: "/files",
  //   component: Layout,
  //   meta: { title: "Файлы", icon: "files" },
  //   redirect: "/files/list",
  //   children: routerFiles("/files"),
  // },
  {
    path: "/regions",
    component: Layout,
    meta: { title: "Регионы", roles: ["admin"] },
    redirect: "/regions/list",
    children: routerRegions("/regions"),
  },
  {
    path: "/stores",
    component: Layout,
    meta: { title: "Магазины", roles: ["admin"] },
    redirect: "/stores/list",
    children: routerStores("/stores"),
  },
  {
    path: "/users",
    component: Layout,
    meta: {
      title: "Пользователи",
      roles: ["admin", "adminregion"],
    },
    redirect: "/users/list",
    children: routerUsers("/users"),
  },
  {
    path: "/banners",
    component: Layout,
    meta: { title: "Баннеры", roles: ["admin"], breadcrumb: false },
    redirect: "/banners/banners/list",
    children: routerBanners("/banners"),
  },
  {
    path: "/materials",
    component: Layout,
    meta: { title: "Материалы", roles: ["admin"] },
    redirect: "/materials/list",
    children: routerMaterials("/materials"),
  },
  {
    path: "/approval",
    component: Layout,
    meta: { title: "Согласование заявки", roles: ["admin"] },
    redirect: "/approval/list",
    children: routerApproval("/approval"),
  },
  {
    path: "/audit",
    component: Layout,
    meta: { title: "Аудит", roles: ["admin"] },
    redirect: "/audit/list",
    children: routerAudit("/audit"),
  },
  { path: "*", redirect: "/404", hidden: true },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 * role='admin' by default has full access
 * note: roles must be a object array! such as: ['developer','editor']
 */
export const asyncRoutes = [
  // {
  //   path: "/bugs",
  //   component: Layout,
  //   meta: { title: "Баги", icon: "nested", roles: ["user"] },
  //   redirect: "/bugs/list",
  //   children: routerBugs("/bugs"),
  // },
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
